/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react"
import _ from "lodash"
import { toast } from "react-toastify"
import { CSVLink } from "react-csv"
import { FaDownload } from "react-icons/fa"
import { archiveCalculator, getExportCsv, getExportResponsesCsv } from "../../../requesters/Backend/CalculatorRequester"
import { addCalculator } from "../../../requesters/Backend/ProgramRequester"

const extractErrorMessage = err => {
  const data = _.get(err, "response.data")
  const detail = _.get(data, "errors[0].detail") || _.get(data, "errors[0].title")
  if (detail) return detail
  if (data?.message) return data.message
  const status = _.get(err, "response.status")
  if (status) return `Error ${status}: ${_.get(err, "response.statusText") || "Something went wrong"}`
  return err?.message || "Something went wrong"
}

function SwitchWithInflight({
  baseUrl, calculatorDetail, calculatorType, currentUser, programDetail, programId, attempts
}) {
  const [csvData, setCsvData] = useState([])
  const [currrentCalculatorDetail, setCurrentCalculatorDetail] = useState({})
  // TODO: fix pulse name/selected pulse survey to be dynamic
  // eslint-disable-next-line no-unused-vars
  const [pulseName, setPulseName] = useState("")
  const [inflight, setInflight] = useState(false)
  const [switchOn, setSwitchOn] = useState(false)
  const [downloadSent, setDownloadSent] = useState(false)
  const [exportType, setExportType] = useState("")
  const [error, setError] = useState("")

  useEffect(() => {
    setCurrentCalculatorDetail(calculatorDetail)
    if (calculatorDetail?.status === "active") {
      setSwitchOn(true)
    } else {
      setSwitchOn(false)
    }
    const latestExport = _.get(calculatorDetail, "recent_exports.0.data")
    if (latestExport) {
      setCsvData(JSON.parse(latestExport))
    }
  }, [calculatorDetail])

  const fetchCsvExport = () => {
    setInflight(true)
    setDownloadSent(true)
    getExportCsv(baseUrl, currrentCalculatorDetail.id, currentUser)
      .then(() => {
        setInflight(false)
        toast.success("Export started. It will appear in Recent Exports when ready.")
        return null
      })
      .catch(err => {
        const errorMessage = extractErrorMessage(err)
        setError(errorMessage)
        setInflight(false)
        toast.error(errorMessage, { autoClose: false })
      })
  }

  const fetchResponsesCsvExport = () => {
    setInflight(true)
    setDownloadSent(true)
    getExportResponsesCsv(baseUrl, currrentCalculatorDetail.id, currentUser)
      .then(() => {
        setInflight(false)
        setExportType("responses")
        toast.success("Export started. It will appear in Recent Exports when ready.")
        return null
      })
      .catch(err => {
        const errorMessage = extractErrorMessage(err)
        setError(errorMessage)
        setInflight(false)
        toast.error(errorMessage, { autoClose: false })
      })
  }

  const onSwitchClick = () => {
    setInflight(true)
    if (currrentCalculatorDetail?.id) {
      archiveCalculator(baseUrl, currrentCalculatorDetail?.id, switchOn ? "archived" : "active", currentUser).then(res => {
        if (res.status === 201) {
          toast[switchOn ? "error" : "success"](`Calculator ${switchOn ? "Deactivated" : "Activated"}`)
          setSwitchOn(!switchOn)
          setInflight(false)
        }
      }).catch(err => {
        setInflight(false)
        toast.error(extractErrorMessage(err))
      })
    } else {
      const params = { program_id: programId, calculator_type: calculatorType }
      addCalculator(baseUrl, params, currentUser).then(res => {
        if (res.status === 201) {
          toast.success(`Added ${calculatorType.replace(/_/g, " ")} to the program`)
          // Do something with response
          setCurrentCalculatorDetail(res.response)
          setSwitchOn(true)
          setInflight(false)
        }
      }).catch(err => {
        setInflight(false)
        toast.error(extractErrorMessage(err))
      })
    }
  }

  const switchUnavailable = calculatorType === "pulse_check" && !currrentCalculatorDetail?.id

  return (
    <>
      <td className="align-middle">
        {!switchUnavailable && (
          inflight ? (
            <div className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <div className="custom-control custom-switch">
              <input
                className="custom-control-input"
                id={`customSwitch-${calculatorType}`}
                type="checkbox"
                onChange={onSwitchClick}
                checked={switchOn} />
              <label className="custom-control-label" htmlFor={`customSwitch-${calculatorType}`}>
                <span className="sr-only">Toggle calculator</span>
              </label>
            </div>
          )
        )}
      </td>
      <td className="align-middle">{attempts ?? 0}</td>
      <td className="align-middle">
        <div className="d-flex align-items-center">
          {currrentCalculatorDetail?.id && !inflight && !error && calculatorType === "matchfit" && (
            <button
              className="btn btn-outline-main btn-sm btn-icon mr-2"
              disabled={downloadSent}
              onClick={fetchResponsesCsvExport}
              type="button">
              <FaDownload />
              Export Responses
            </button>
          )}
          {currrentCalculatorDetail?.id && !inflight && !error && (
            <button
              className="btn btn-outline-main btn-sm btn-icon"
              disabled={downloadSent}
              onClick={fetchCsvExport}
              type="button">
              <FaDownload />
              Export CSV
            </button>
          )}
        </div>
      </td>
    </>
  )
}

export default SwitchWithInflight
